import { render, staticRenderFns } from "./DeclinedSmsReplyMessages.vue?vue&type=template&id=af274b66&scoped=true"
import script from "./DeclinedSmsReplyMessages.vue?vue&type=script&lang=js"
export * from "./DeclinedSmsReplyMessages.vue?vue&type=script&lang=js"
import style0 from "./DeclinedSmsReplyMessages.vue?vue&type=style&index=0&id=af274b66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af274b66",
  null
  
)

export default component.exports